import { UnitAction, UnitActionType } from "../../Controls/FormParts/Unit/Store/unitActions";
import { UnitId } from "../../Controls/FormParts/Unit/UnitId/UnitId";

export function setUnitTableWidth(tableId: string, unitId: UnitId, width: number): UnitAction {
    return {
        type: UnitActionType.SetUnitTableWidth,
        payload: {
            tableId: tableId,
            unitId: unitId,
            width: width,
        },
    };
}

export function removeUnitTableWidth(tableId: string, unitId: UnitId): UnitAction {
    return {
        type: UnitActionType.RemoveUnitTableWidth,
        payload: {
            tableId: tableId,
            unitId: unitId,
        },
    };
}
